import { fetchQuery, graphql } from "relay-runtime"
import { findDePatientByInternalIdQuery as QueryType } from "@/modules/patients/manage-duplicates/services/de/__generated__/findDePatientByInternalIdQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query findDePatientByInternalIdQuery($internalId: Int!) {
    de_patientByInternalId(patientInternalId: $internalId) {
      id
      firstName
      lastName
      gender
      displayId
      contactChannel
      country
      duplicatePatients {
        id
        firstName
        lastName
        gender
        displayId
        contactChannel
      }
    }
  }
`

const findDePatientByInternalId = (internalId: number) => {
  return fetchQuery<QueryType>(RelayEnvironment, query, { internalId }).toPromise()
}

export { findDePatientByInternalId }
